import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';

export default mergeStyleSets({
  dragEnter: {
    backgroundColor: theme.palette.neutralLight,
  },
  tableColumn: {
    backgroundColor: 'transparent',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
    selectors: {
      '& .ms-DetailsHeader-cellTitle': {
        paddingTop: '0.5rem',
        paddingLeft: 0,
        paddingRight: 0,
        overflow: 'unset',
      },
      '& .ms-DetailsHeader-cellName': {
        overflow: 'unset',
        flexGrow: 1,
      },
    },
  },
});
